import { createIntroOfferProductId, createProductId } from 'helpers'

import {
  selectCookieConsentCountries,
  selectScreenName,
  selectStripeAccountId,
  selectStripeAccountName,
} from 'root-redux/selects/common'
import {
  selectCookieConsent,
  selectEmail,
  selectUUID,
  selectUserCountryCode,
} from 'root-redux/selects/user'

import { IAppState } from 'models/store.model'

import {
  selectCurrency,
  selectSubscription,
  selectSubscriptionFullPrice,
  selectSubscriptionLookupKey,
  selectSubscriptionPeriodName,
  selectSubscriptionPeriodQuantity,
  selectSubscriptionTrialLookupKey,
  selectSubscriptionTrialPeriodDays,
  selectSubscriptionTrialPeriodPrice,
} from 'modules/payment/redux/selects'

import {
  CookieConsentOption,
  CountryCode,
  USA_STATES_WITH_COOKIES,
} from 'root-constants/common'

export const getPurchaseCommonEventParams = (state: IAppState) => {
  const uuid = selectUUID(state)
  const email = selectEmail(state)
  const stripePriceId = selectSubscriptionLookupKey(state)
  const price = selectSubscriptionFullPrice(state)
  const trialPrice = selectSubscriptionTrialPeriodPrice(state)
  const trialPeriodDays = selectSubscriptionTrialPeriodDays(state)
  const trialPriceId = selectSubscriptionTrialLookupKey(state)
  const trialPeriodQuantity = selectSubscriptionTrialPeriodDays(state)
  const currency = selectCurrency(state)
  const screenName = selectScreenName(state)
  const stripeAccountName = selectStripeAccountName(state)
  const stripeAccountId = selectStripeAccountId(state)
  const periodName = selectSubscriptionPeriodName(state)
  const periodQuantity = selectSubscriptionPeriodQuantity(state)
  const cookieConsent = selectCookieConsent(state)
  const cookieConsentCountries = selectCookieConsentCountries(state)
  const userCountryCode = selectUserCountryCode(state)
  const selectedSubscription = selectSubscription(state)

  const isEUUser = cookieConsentCountries.includes(
    userCountryCode.toUpperCase(),
  )
  const isUSAUser = userCountryCode.toUpperCase() === CountryCode.UNITED_STATES
  const isUSAWithCookieConsent =
    isUSAUser && USA_STATES_WITH_COOKIES.includes(userCountryCode.toUpperCase())

  const shouldApplyCookieConsent = isEUUser || isUSAWithCookieConsent

  const productId = trialPriceId
    ? createIntroOfferProductId({
        priceId: stripePriceId,
        trialPriceId,
        trialPeriodQuantity,
      })
    : createProductId({
        periodName,
        periodQuantity,
        price,
      })

  const isPersonalDataAllowed =
    !shouldApplyCookieConsent ||
    (shouldApplyCookieConsent &&
      (cookieConsent || []).includes(
        CookieConsentOption.ADVERTISING_AND_TARGETING,
      ))

  return {
    uuid,
    email,
    price,
    trialPrice,
    trialPriceId,
    trialPeriodDays,
    currency,
    periodName,
    periodQuantity,
    screenName,
    productId,
    stripeAccountName,
    stripeAccountId,
    stripePriceId,
    isPersonalDataAllowed,
    selectedSubscription,
  }
}
